import { AxiosInstance } from "axios"
import { api } from "../../Configurations/axios"
import { IFormItemsSubvention, IFormItemsSubventionPut } from "../pages/register/subvention"
import { IFormItemsRefundable, IFormItemsRefundablePut } from "../pages/register/refundable"

interface Ifavorite {
    FavoritesGrantsId: string
    FavoritesGrantsName: string
    CompanyId: string
    UserEmail: string
    FavoritesGrantOrganism: string
    FavoritesGrantDescription: string
}

class FinancialLines {

    client: AxiosInstance = api

    /**
     * @summary (GET) Pega a listagem geral de linhas de financiamento
     * 
     * @param page elemento de paginaçãp
     * @param take quantos elementos vão estar presente na tela
     * @param word ?
     */
    public async getFinancialLinesList(page: number = 1, word: string = 'all', take: number = 7): Promise<any> {
        const response = await this.client.get(`/financinglines/GetFinancingLinesPaginated?page=${page}&take=${take}&word=${word === '' ? 'all' : word}`)
        return response.data
    }

    /**
     * @summary (GET) Pega um contrato de subvenção único
     * 
     * @param id identificador do elemento a ser procurado
     */
    public async getSubvetion(id: string): Promise<any> {
        const response = await this.client.get(`/Subventions/GetSubvention?financingId=${id}`)
        return response.data
    }

    /**
     * @summary (GET) Pega um contrato de refundable único
     * 
     * @param id identificador do elemento a ser procurado
     */
    public async getRefundable(id: string): Promise<any> {
        const response = await this.client.get(`/Refundables/GetRefundable?financingId=${id}`)
        return response.data
    }

    /**
     * @summary (POST) Seta um contrato de subvenção único
     * 
     * @param formData Dados que vem do formulário de subvenção
     */
    public async postSubvetion(formData: IFormItemsSubvention): Promise<any> {

        const response = await this.client.post(`/Subventions/CreateSubvention`, {
            userEmail: formData.email_usuario,
            Goal: formData.objetivo,
            Title: formData.titulo_da_linha,
            Value: formData.valores,
            BankName: formData.banco,
            Coverage: formData.abrangencia,
            Counterpart: formData.contrapartida,
            LinkLearnMore: formData.link_saiba_mais,
            Deadlines: formData.prazos,
            TypeOfBeneficiary: formData.tipo_de_beneficiario,
            IsVisible: formData.ativar_linha
        })

        return response.data
    }

    /**
     * @summary (POST) Seta um contrato de reembolsável único
     * 
     * @param formData Dados que vem do formulário de reembolsável
     */
    public async postRefundable(formData: IFormItemsRefundable): Promise<any> {

        // FIXME - INFORMAÇÕES A BAIXO QUE NÃO ESTÃO MAPEADAS NÃO EXISTEM NO GET
        const response = await this.client.post(`/Refundables/CreateRefundable`, {
            UserEmail: formData.email_usuario,
            BankName: formData.banco,
            Title: formData.titulo_da_linha,
            LinkLearnMore: formData.link_saiba_mais ,
            IsVisible: formData.ativar_linha,
            Coverage: formData.abrangencia,
            Summary: formData.resumo,
            CanBeFinanced: "Sim", 
            InterestRates: formData.taxa_juros, 
            GracePeriods: formData.prazo_total,
            TotalTerm: formData.prazo_total,
            ParticipationBank: formData.banco_de_fomento,
            CompanySize: formData.porte_da_empresa,
            Sectors: formData.setores,
            AdditionalInformation: '',
        })
        return response.data
    }

    /**
     * @summary (PUT) Atualiza um contrato reembolsável único
     * 
     * @param formData Dados que vem do formulário de subvenção
     */
    public async putRefundable(formData: IFormItemsRefundablePut): Promise<any> {
        return await this.client.put(`/Refundables/EditRefundables`, formData)
    }

    /**
     * @summary (PUT) Atualiza um contrato de subvenção único
     * 
     * @param formData Dados que vem do formulário de subvenção
     */
    public async putSubvention(formData: IFormItemsSubventionPut): Promise<any> {
        return await this.client.put(`/Subventions/EditSubvention`, formData)
    }


    public async getFavorites(companyId: string): Promise<any> {
        const { data } = await this.client.get(`/GrantsLine/GetFavoriteGrants?CompanyId=${companyId}`)
        return data
    }

    public async setFavorite(d: Ifavorite) {
        const { data } =  await this.client.post(`/GrantsLine/UpdateGrant`, d)
        return data
    }

}

export const FinancialLinesService = new FinancialLines()